<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <span>Kehadiran</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Laporan Kehadiran</h2>
                <p class="page-subtitle">Rekod Kehadiran Kuliah & Program Tamhidi</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-6">
                    
                    <!-- Perkuliahan Section -->
                    <div class="attendance-section mb-4">
                        <div class="section-header">
                            <i class="fas fa-graduation-cap"></i>
                            <h5>Perkuliahan Terdaftar</h5>
                        </div>
                        
                        <div v-if="registered_list.length === 0" class="empty-state">
                            <i class="fas fa-inbox"></i>
                            <p>Tiada perkuliahan terdaftar</p>
                        </div>
                        
                        <div class="semester-list">
                            <div class="semester-item" v-for="(item, index) in registered_list" :key="index">
                                <div class="semester-info">
                                    <i class="fas fa-calendar-alt"></i>
                                    <span class="semester-text">{{ item.term }} / {{ item.academic_year }}</span>
                                </div>
                                <router-link :to="{name: 'AttendanceSubject', params:{'sr_id': item.sr_id}}">
                                    <button class="btn-detail">
                                        Perinci <i class="fas fa-arrow-right"></i>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <!-- Tamhidi Section -->
                    <div class="attendance-section">
                        <div class="section-header">
                            <i class="fas fa-book-open"></i>
                            <h5>Pengajian Tamhidi</h5>
                        </div>
                        
                        <div v-if="tamhidi_registered_list.length === 0" class="empty-state">
                            <i class="fas fa-inbox"></i>
                            <p>Tiada program tamhidi terdaftar</p>
                        </div>
                        
                        <div class="semester-list">
                            <div class="semester-item" v-for="(item, index) in tamhidi_registered_list" :key="index">
                                <div class="semester-info">
                                    <i class="fas fa-calendar-alt"></i>
                                    <span class="semester-text">Semester {{ item.semester }} / {{ item.year }}</span>
                                </div>
                                <router-link :to="{name: 'TamhidiAttendanceSubject', params:{'semester': item.semester, 'year': item.year}}">
                                    <button class="btn-detail">
                                        Perinci <i class="fas fa-arrow-right"></i>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/services/BackendService'
    export default {
        mounted(){
            this.retreiveAttendance()    
            this.retreiveTamhidiRegistered()
        },
        data(){
            return{
                registered_list: [],
                tamhidi_registered_list: []
            }
        },
        methods:{
            retreiveTamhidiRegistered(){
                http.get(`tamhidi/registered`)
                    .then(response => {
                        this.tamhidi_registered_list = response.data.data
                    })
                    .catch(error => {
                        if(error.response.status == 401 || error.response.status == 419){
                            this.$store.dispatch("authentication/cencelAuthen")
                        }
                    })
            },
            retreiveAttendance(){
                this.$Progress.start()
                http.get(`learning/retreiveStudentRegistered`)
                    .then(response => {
                        this.registered_list = response.data.data
                        this.$Progress.finish()
                    })
                    .catch(error => {
                        if(error.response.status == 401 || error.response.status == 419){
                            this.$store.dispatch("authentication/cencelAuthen")
                        }
                        this.$Progress.fail()
                    })
            }
        } 
    }
</script>

<style scoped>
.attendance-section {
    background: var(--bg-white);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-md);
    overflow: hidden;
}

.section-header {
    background: var(--primary-gradient);
    color: var(--text-white);
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.section-header i {
    font-size: 1.3rem;
}

.section-header h5 {
    margin: 0;
    font-weight: 600;
    font-size: 1.1rem;
}

.semester-list {
    padding: 8px;
}

.semester-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
    transition: var(--transition-fast);
}

.semester-item:last-child {
    border-bottom: none;
}

.semester-item:hover {
    background: #f8f9fa;
}

.semester-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.semester-info i {
    color: var(--primary-color);
    font-size: 1.1rem;
}

.semester-text {
    font-weight: 500;
    color: var(--text-primary);
}

.btn-detail {
    background: var(--primary-gradient);
    color: var(--text-white);
    border: none;
    padding: 8px 16px;
    border-radius: var(--border-radius-sm);
    font-weight: 500;
    font-size: 0.85rem;
    cursor: pointer;
    transition: var(--transition-normal);
    display: flex;
    align-items: center;
    gap: 6px;
}

.btn-detail:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-sm);
}

.empty-state {
    text-align: center;
    padding: 40px 20px;
    color: var(--text-secondary);
}

.empty-state i {
    font-size: 2.5rem;
    margin-bottom: 12px;
    opacity: 0.5;
}

.empty-state p {
    margin: 0;
    font-size: 0.95rem;
}
</style>